'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

require('./index.scss');

var _RailNavItem = require('./RailNavItem');

var _RailNavItem2 = _interopRequireDefault(_RailNavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileLayout = function ProfileLayout(_ref) {
    var children = _ref.children,
        links = _ref.links,
        name = _ref.name,
        nickName = _ref.nickName,
        avatar = _ref.avatar,
        theme = _ref.theme,
        additionalInfo = _ref.additionalInfo;

    return _react2.default.createElement(
        'div',
        { className: 'cc-profile-layout-comp' },
        _react2.default.createElement(
            'div',
            { className: 'rail' },
            _react2.default.createElement(
                'div',
                null,
                (0, _isFunction2.default)(avatar) && _react2.default.createElement(
                    'div',
                    { className: 'avatar-wrapper' },
                    avatar()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'name-wrapper' },
                    _react2.default.createElement(
                        'span',
                        null,
                        name
                    ),
                    (0, _isString2.default)(nickName) && _react2.default.createElement(
                        'div',
                        { className: 'nickname' },
                        '"',
                        nickName,
                        '"'
                    )
                ),
                additionalInfo
            ),
            _react2.default.createElement(
                'div',
                { className: 'links-wrapper' },
                _react2.default.createElement(
                    _Nav2.default,
                    { stacked: true,
                        className: (0, _classnames2.default)('profile-links', theme),
                        bsStyle: 'pills' },
                    links.map(function (item, idx) {
                        return _react2.default.createElement(_RailNavItem2.default, {
                            key: idx,
                            item: item
                        });
                    })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'content' },
            children
        )
    );
};

ProfileLayout.propTypes = {
    additionalInfo: _propTypes2.default.node,
    name: _propTypes2.default.string,
    nickName: _propTypes2.default.string,
    avatar: _propTypes2.default.func,
    children: _propTypes2.default.node.isRequired,
    links: _propTypes2.default.array.isRequired,
    theme: _propTypes2.default.oneOf(['light', 'default'])
};
ProfileLayout.defaultProps = {
    theme: 'default'
};

exports.default = ProfileLayout;
//# sourceMappingURL=index.js.map